import React from "react";
import HeaderThree from "../../Components/Header/HeaderThree";
import MediaGallerySkeleton from "./DetailMediaShell";

const SkeletonLine = ({ className = "" }) => (
  <div className={`animate-pulse rounded-full bg-slate-200/80 ${className}`} />
);

const DestinationHeroSkeleton = () => (
  <div
    id="overview-section-overview"
    className="min-h-[522px] rounded-3xl border border-[#e3edf6] bg-white shadow-[0_20px_80px_rgba(16,50,77,0.10)] scroll-mt-[120px]"
    data-detail-destination-hero-state="loading"
    aria-busy="true"
    aria-label="Loading destination overview"
  >
    <div className="h-64 w-full animate-pulse rounded-[28px] bg-slate-200/80" aria-hidden="true" />
    <div className="space-y-4 p-6" aria-hidden="true">
      <SkeletonLine className="h-6 w-32" />
      <SkeletonLine className="h-8 w-1/2" />
      <SkeletonLine className="h-4 w-2/3" />
      <SkeletonLine className="h-4 w-3/4" />
      <div className="flex flex-wrap gap-2">
        <SkeletonLine className="h-3 w-24" />
        <SkeletonLine className="h-3 w-20" />
        <SkeletonLine className="h-3 w-16" />
      </div>
    </div>
  </div>
);

const CampHeroSkeleton = () => (
  <section id="overview" className="scroll-mt-24" aria-busy="true" aria-label="Loading camp overview">
    <header
      className="min-h-[220px] rounded-[28px] border border-[#dfeaf4] bg-white p-4 shadow-[0_22px_80px_rgba(16,50,77,0.08)] sm:min-h-[200px] sm:p-6"
      data-detail-hero-state="loading"
    >
      <div className="flex items-center gap-2 sm:gap-3" aria-hidden="true">
        <SkeletonLine className="h-6 w-28" />
        <div className="ml-auto flex gap-2">
          <SkeletonLine className="h-10 w-10" />
          <SkeletonLine className="h-10 w-10" />
          <SkeletonLine className="h-10 w-10" />
        </div>
      </div>
      <div className="mt-4 space-y-3" aria-hidden="true">
        <SkeletonLine className="h-9 w-4/5 sm:w-1/2" />
        <SkeletonLine className="h-4 w-2/3" />
        <div className="space-y-2 pt-1">
          <SkeletonLine className="h-3 w-full" />
          <SkeletonLine className="h-3 w-11/12" />
          <SkeletonLine className="h-3 w-3/4" />
        </div>
        <SkeletonLine className="h-5 w-3/5 pt-1" />
        <div className="flex gap-2 pt-1">
          <SkeletonLine className="h-7 w-24" />
          <SkeletonLine className="h-7 w-28" />
        </div>
      </div>
    </header>
  </section>
);

const DetailFirstPaintShell = ({ kind = "destination", title = "", withHeader = true }) => {
  if (kind === "camp" || kind === "experience") {
    const isExperience = kind === "experience";
    return (
      <>
        {withHeader ? (
          isExperience ? <HeaderThree isStickyDisabled /> : <HeaderThree initialAppearance="overlay" />
        ) : null}
        <main id="top" className="bg-[#f3f9fc]">
          <div
            className={isExperience
              ? "mx-auto w-[90vw] pb-24"
              : "mx-auto w-full max-w-[1440px] px-4 pb-24 max-[639px]:px-0 sm:px-6 lg:px-8"}
            style={{ paddingTop: "calc(var(--landing-header-offset, 80px) + clamp(1.5rem, 2.5vw, 2.5rem))" }}
          >
            <MediaGallerySkeleton id={isExperience ? "experience-media-gallery" : "camp-media-gallery"} title={title} />
            <div className="mt-3">
              <CampHeroSkeleton />
            </div>
          </div>
        </main>
      </>
    );
  }

  return (
    <>
      <div className="mx-auto mt-20 w-[95vw] max-w-none px-0 py-3">
        <MediaGallerySkeleton id="overview-section-media-gallery" title={title} />
      </div>
      <HeaderThree />
      <main
        className="bg-[linear-gradient(180deg,#f6fafc_0%,#f3f8fb_35%,#f6fafc_100%)] pb-20 pt-[86px]"
      >
        <div className="mx-auto w-full max-w-[1440px] px-3 sm:px-6 lg:px-8">
          <div className="mb-6 space-y-5">
            <DestinationHeroSkeleton />
          </div>
        </div>
      </main>
    </>
  );
};

export default DetailFirstPaintShell;
